module.exports = __webpack_public_path__ + "static/Velocity_Chime_VMA_VOTING_DELIVERY_DDT_2-c6867637b04b9fd156d27572e90d0d0e.mp4";